import i18n from "@/i18n";
/**
 * WorkforceLayout — Prompt 10A §12-§13, extended by Prompt 13C.
 *
 * Frontend Workforce shell responsible only for:
 *   • the permanent secondary navigation (Schedule | Review Hours | Team);
 *   • rendering the nested/current Workforce page via <Outlet />.
 *
 * Prompt 13C — the previous "exactly two entries Schedule | Team /
 * no Review Hours" freeze is SUPERSEDED by owner authorization. The
 * canonical secondary navigation is now EXACTLY three entries, in
 * this order: Schedule · Review Hours · Team. No dashboard, no
 * Employees, no Clock, no Reports, no Settings tabs are permitted
 * here.
 *
 * The visual language reuses MiseOne conventions (border, spacing,
 * typography, active-state) — no new design system is introduced.
 */
import { NavLink, Outlet } from "react-router-dom";

const SECONDARY_NAV = [
    { to: "/workforce", end: true, get label() { return i18n.t("wf.workforceLayout.schedule", "Schedule"); },
      testId: "workforce-nav-schedule" },
    { to: "/workforce/review-hours", end: false, get label() { return i18n.t("wf.workforceLayout.reviewHours", "Review Hours"); },
      testId: "workforce-nav-review-hours" },
    { to: "/workforce/team", end: false, get label() { return i18n.t("wf.workforceLayout.team", "Team"); },
      testId: "workforce-nav-team" },
    { to: "/workforce/external-extras", end: false, get label() { return i18n.t("wf.workforceLayout.externalExtras", "External extras"); },
      testId: "workforce-nav-external-extras" },
];

export default function WorkforceLayout() {
    return (
        <div data-testid="workforce-layout" className="flex flex-col">
            <nav
                data-testid="workforce-secondary-nav"
                className="border-b border-neutral-200 bg-white"
            >
                <div className="flex items-center gap-1 px-4 sm:px-6
                                    overflow-x-auto">
                    {SECONDARY_NAV.map((item) => (
                        <NavLink
                            key={item.to}
                            to={item.to}
                            end={item.end}
                            data-testid={item.testId}
                            className={({ isActive }) =>
                                `inline-flex items-center px-3 py-2 my-1 text-sm
                                 border-b-2 rounded-t-md transition-colors
                                 ${isActive
                                     ? "border-[hsl(var(--accent))] bg-[hsl(var(--accent-soft))] text-neutral-900 font-semibold"
                                     : "border-transparent text-neutral-500 font-medium "
                                         + "hover:text-neutral-900 hover:bg-neutral-50"}`}
                        >
                            {item.label}
                        </NavLink>
                    ))}
                </div>
            </nav>
            <Outlet />
        </div>
    );
}

export { SECONDARY_NAV };
